
// INTERNSHIP STRUCTURES
export const GET_INTERNSHIP_STRUCTURES = "/internship-structures";
export const ADD_NEW_INTERNSHIP_STRUCTURE = "/internship-structures";
export const UPDATE_INTERNSHIP_STRUCTURE = "/internship-structures";
export const DELETE_INTERNSHIP_STRUCTURE = "/internship-structures";


